<section class="intro">
  <div>
    <h1 class="font-extrabold" paint="blue">About us.</h1>
    <p>
      Welcome to cloudigo, the ultimate discount app that connects you to 1000+ discounts from 350+ top brands in Malta. From your favorite restaurants and fashion shops to food outlets, toy shops, and even pet shops, we got you covered.
      <br/>
      <br/>
      Our app is designed to help consumers save money while also driving traffic to participating stores. However, we're proud to offer cloudigo as an employee benefit to hundreds of companies in Malta, allowing their employees to enjoy exclusive savings on the go.
      <br/>
      Join the cloudigo community today and start saving on everything you love!
    </p>
  </div>
  <img src="old/about/about-us.jpg" alt="About Us"/>
</section>

@defer {
  <section class="our-cards" [@fadeUp]>
    <div paint="accent">
      <mat-icon paint="accent" svgIcon="about-service"></mat-icon>
      <h1 class="font-extrabold">Our Service</h1>
      <h3 class="font-light">Our platform allows all sorts of brands to give added value to the cloudigo club by providing vouchers, discounts, promotions, specific services and more. In return, cloudigo helps brands gain footfall and sales.</h3>
    </div>
    <div paint="primary">
      <mat-icon paint="primary" svgIcon="about-values"></mat-icon>
      <h1 class="font-extrabold">Our Values</h1>
        <h3 class="font-light">cloudigo is based on the core values of reliability, innovation and user experience. We strive to give the best service out there to our partnering brands, as well as our subscribers.</h3>
    </div>
    <div paint="warn">
      <mat-icon paint="warn" svgIcon="about-mission"></mat-icon>
      <h1 class="font-extrabold">Our Mission</h1>
        <h3 class="font-light">Our mission is to connect brands with consumers in the most innovative manner and provide the best user experience out there to our users.</h3>
    </div>
  </section>
  <main>
    <div class="image-container" style="grid-row: span 2; grid-column: span 2;">
      <img src="old/about/h5.jpeg" style="object-fit: contain;" alt="Staff Photo of Christmas 2023"/>
    </div>
    <div class="image-container">
      <img src="old/about/h1.JPG" alt="Staff Photo from Team building event"/>
  
    </div>
    <div class="image-container" style="grid-row: span 2;">
      <img src="old/about/v2.jpeg" alt="Staff Photo of Christmas Party"/>
    </div>
    <div class="image-container">
      <img src="old/about/s1.png" alt="Staff Photo at websummit"/>
    </div>
  </main>
}